import { lazy } from 'react';

export const routes = [
    {
        component: lazy(() => import('module/econsent/Document')),
        permissions: [],
        path: '/icf-export',
    },
];
